import React from 'react';
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import Avatar from "../../../atoms/avatar";
import {Container, Address, Info, Rate, StarsCard} from "./styles";
import Stars from "../../../atoms/stars";
import {isEmpty} from "../../../helpers/helpers";
import ButtonBase from "../../../atoms/button.base";
import Icon from "../../../atoms/icon";
import {useWindowSize} from "../../../helpers/windows.size";

const AgenciesCardSkeleton = () => {
    const windowSize = useWindowSize();

    return (
        <Container className="mt-0 mt-lg-16">
            <div className="skeleton-parent position-relative d-block">
                <Skeleton width={windowSize > 991 ? 88 : 56} height={windowSize > 991 ? 88 : 56} circle/>
            </div>

            <Info className="mr-16 mr-lg-0 mt-0 mt-lg-8">

                <Skeleton width="70%" height={14}/>

                <div className="skeleton-parent mt-4 mt-lg-8">
                    <Skeleton width="100%" height={14}/>
                </div>

                <Address className="skeleton-parent mt-8">
                    <Skeleton width="100%" height={14}/>
                </Address>

                <div className="d-none d-lg-block mt-16">
                    <Skeleton width={124} height={36}/>
                </div>
            </Info>

        </Container>
    );
};

export default React.memo(AgenciesCardSkeleton);

// styles

/*
const Container = styled.div`
  width: 100%;
  height: 303px;
  
  .react-loading-skeleton {
    border-radius: 16px;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {
    height: 118px;
  }
`;*/
